import {action} from 'typesafe-actions';
import {Popup, PopupActionTypes} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const showPopup = (popup: Popup) => action(PopupActionTypes.SHOW_POPUP, popup);
export const closePopup = () => action(PopupActionTypes.CLOSE_POPUP);
